import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'
import User from 'model/User'

export class UserRepository extends WebRepository<User> {
  constructor() {
    super(new Api('users'))
  }

  async search(text: string): Promise<User[]> {
    return super.search({
      selector: {
        $or: [
          {
            userName: text,
          },

          {
            givenNameInit: {
              $regex: '(?i)' + text,
            },
          },
          {
            FamilyNameInit: {
              $regex: '(?i)' + text,
            },
          },
        ],
      },
      bookmark: '',
      limit: 10,
    })
  }

  async searchInGroup(text: string, groupId: string): Promise<User[]> {
    return super.search({
      groupId,
      selector: {
        $or: [
          {
            userName: text,
          },
          {
            givenNameInit: {
              $regex: '(?i)' + text,
            },
          },
          {
            FamilyNameInit: {
              $regex: '(?i)' + text,
            },
          },
        ],
      },
      bookmark: '',
      limit: 10,
    })
  }
}

export default new UserRepository()
